import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { GlobalLoadingService, LoadingDomain } from '@core/loading/global-loading.service';

export const SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);
export const LOADING_DOMAIN = new HttpContextToken<LoadingDomain>(() => 'content');

export const globalLoadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_GLOBAL_LOADING)) {
    return next(req);
  }

  const loading = inject(GlobalLoadingService);
  const domain = req.context.get(LOADING_DOMAIN);

  loading.start(domain);

  return next(req).pipe(finalize(() => loading.stop(domain)));
};
